<div class="perfil-autocomplete">
  <input
    type="text"
    class="form-select campanha-form-control perfil-autocomplete-campo"
    role="combobox"
    autocomplete="off"
    placeholder="Selecione um perfil"
    aria-autocomplete="list"
    [id]="inputId()"
    [value]="texto()"
    [disabled]="desabilitado()"
    [attr.aria-expanded]="aberto()"
    [attr.aria-controls]="listaId()"
    [attr.aria-activedescendant]="indiceAtivo() >= 0 ? opcaoId(indiceAtivo()) : null"
    (input)="onDigitar($any($event.target).value)"
    (keydown)="onTeclar($event)"
    (click)="alternarLista()"
    (blur)="onSairDoCampo()"
    data-testid="input-perfil-associado"
  />

  @if (aberto()) {
    <ul class="perfil-autocomplete-lista" role="listbox" [id]="listaId()">
      @for (opcao of opcoesFiltradas(); track opcao.id; let i = $index) {
        <!-- mousedown com preventDefault mantém o foco no campo, senão o blur fecha a lista antes do clique. -->
        <li
          class="perfil-autocomplete-opcao"
          role="option"
          [id]="opcaoId(i)"
          [class.perfil-autocomplete-opcao--ativa]="i === indiceAtivo()"
          [attr.aria-selected]="estaSelecionada(opcao)"
          (mousedown)="$event.preventDefault()"
          (click)="selecionar(opcao)"
          data-testid="opcao-perfil-associado"
        >
          {{ opcao.nome }}<span class="perfil-autocomplete-data"> - {{ opcao.data }}</span>
        </li>
      } @empty {
        <li class="perfil-autocomplete-vazio" data-testid="perfil-autocomplete-vazio">
          @if (texto()) {
            Nenhum perfil encontrado para "{{ texto() }}".
          } @else {
            Todos os perfis cadastrados já foram associados.
          }
        </li>
      }
    </ul>
  }
</div>
